import React from 'react';
import { Search, GitCompareArrows, Rocket } from 'lucide-react';

const steps = [
  {
    icon: Search,
    title: 'Discover',
    description: 'Browse 150+ curated AI tools across 25+ categories — from coding to creative work.',
  },
  {
    icon: GitCompareArrows,
    title: 'Compare',
    description: 'Evaluate tools side-by-side on pricing, features, and real user ratings.',
  },
  {
    icon: Rocket,
    title: 'Use',
    description: 'Launch your chosen tool directly or save it to your workspace for later.',
  },
];

export const HowItWorks: React.FC = () => {
  return (
    <section className="py-20 px-4">
      <div className="container mx-auto max-w-5xl">
        <h2 className="text-3xl font-bold text-center mb-4">How It Works</h2>
        <p className="text-center text-muted-foreground mb-12 max-w-xl mx-auto">
          Find your perfect AI tool in three simple steps.
        </p>
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, i) => (
            <div key={i} className="text-center space-y-4">
              <div className="mx-auto w-14 h-14 rounded-full border-2 border-border flex items-center justify-center">
                <step.icon className="w-6 h-6 text-foreground" />
              </div>
              <div className="text-sm font-medium text-muted-foreground">Step {i + 1}</div>
              <h3 className="text-xl font-semibold">{step.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
